var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.otroDocumento
    ? _c(
        "table",
        { staticClass: "table is-narrow is-fullwidth is-marginless" },
        [
          _c("tbody", [
            _c("tr", [
              _c("th", [
                _vm._v(
                  _vm._s(
                    _vm.constants.STRINGS.TABLES.OTRO_DOCUMENTO_INFORMATION.TYPE
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(_vm.otroDocumento.tipo_otro_documento.nombre)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  _vm._s(
                    _vm.constants.STRINGS.TABLES.OTRO_DOCUMENTO_INFORMATION
                      .UPLOAD_DATE
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("moment")(
                      new Date(_vm.otroDocumento.created_at),
                      "dddd, DD/MM/YYYY, HH:mm:ss"
                    )
                  ) + " "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  _vm._s(
                    _vm.constants.STRINGS.TABLES.OTRO_DOCUMENTO_INFORMATION
                      .STATE
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.otroDocumento.estado) + " ")]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { width: "250px" } }, [
                _vm._v(
                  _vm._s(
                    _vm.constants.STRINGS.TABLES.OTRO_DOCUMENTO_INFORMATION
                      .SCOPE
                  )
                ),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(this.getScopeText) + " ")]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }